module.exports = function getResource(label) {
    let resources = {
        shopNow: 'Magasiner',
        video: 'Vidéo'
    };

    return resources[label];
};
